import { Link } from "react-router-dom";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Footer = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: false,
    });
  }, []);
  return (
    <>
      <footer className="footer">
        <div className="container">
          <div className="footer-top">
            <div className="row">
              <div className="col-lg-6">
                <div className="info-wraper">
                  <div className="footer-card-header d-flex justify-content-between mb-4">
                    <div className="footer-info-heading">
                      <p>Work Hours</p>
                    </div>
                    <div className="footer-info-icon">
                      <img src="/clock.png" alt="" />
                    </div>
                  </div>
                  <div className="footer-info-line">
                    <p>Monday - Friday:</p>
                    <span>8 AM to 6 PM</span>
                  </div>
                  <div className="footer-info-line">
                    <p>Saturday:</p>
                    <span>8 AM to 2 PM</span>
                  </div>
                  <div className="footer-info-line">
                    <p>Sunday:</p>
                    <span>Off</span>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="info-wraper">
                  <div className="footer-card-header d-flex justify-content-between mb-4">
                    <div className="footer-info-heading">
                      <p>Address</p>
                    </div>
                    <div className="footer-info-icon">
                      <img src="/phone-book.png" alt="" />
                    </div>
                  </div>
                  <div className="footer-address-line mb-3">
                    <i className="bi bi-geo-alt"></i>{" "}
                    <span>Siliguri, West Bengal, India</span>
                  </div>
                  <div className="footer-address-line mb-3">
                    <i className="bi bi-telephone"></i>{" "}
                    <span>
                      <a href="tel:+919832757427">+91 9832757427</a>
                    </span>
                  </div>
                  <div className="footer-address-line mb-1">
                    <i className="bi bi-envelope-at"></i>{" "}
                    <span>
                      <a href="mailto:smartscholars360.bikash@gmail.com">
                        smartscholars360.bikash@gmail.com
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-mid">
            <div className="ss360-logo">
              <img src="/Footer-logo.webp" alt="" />
            </div>
          </div>
          <div className="footer-bottom">
            <div className="social-box">
              <a
                href="https://www.facebook.com/share/1BPw9JHv34/"
                className="social"
                target="__blank"
              >
                <i className="bi bi-facebook"></i>
              </a>
              <a
                href="https://wa.me/919832757427"
                className="social"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-whatsapp"></i>
              </a>
              <a
                href="https://www.instagram.com/smartscholars360?igsh=bmtlY2xidjcyMGU="
                className="social"
                target="__blank"
              >
                <i className="bi bi-instagram"></i>
              </a>
            </div>
            <div className="footer-nav mt-5">
              <ul className="nav justify-content-center border-bottom pb-3 mb-5">
                <li className="nav-item">
                  <Link to="/" className="nav-link px-2 text-body-secondary">
                    Home
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/about"
                    className="nav-link px-2 text-body-secondary"
                  >
                    About
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/services"
                    className="nav-link px-2 text-body-secondary"
                  >
                    Service
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/courses"
                    className="nav-link px-2 text-body-secondary"
                  >
                    Courses
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/blogs"
                    className="nav-link px-2 text-body-secondary"
                  >
                    Blogs
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/events"
                    className="nav-link px-2 text-body-secondary"
                  >
                    Events
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/notice"
                    className="nav-link px-2 text-body-secondary"
                  >
                    Notice
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/contact"
                    className="nav-link px-2 text-body-secondary"
                  >
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
            <p className="text-center text-body-secondary">
              {new Date().getFullYear()} &copy; SmartScholars360
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
